import React, { FC } from 'react';
import { Alert, Badge, Button, Toggle } from '@kontentino/ui';
import Link from 'components/shared/Link';
import { useTranslation } from 'react-i18next';
import { Attachments } from 'types/Attachments';

type Props = {
  value: Pick<Attachments, 'is_trial_reel' | 'share_to_everyone_automatically'>;
  onChange: (
    fn: (
      attachments: Attachments,
    ) => Pick<Attachments, 'is_trial_reel' | 'share_to_everyone_automatically'>,
  ) => void;
};

const PostComposerTrialReelInstagram: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <div
        className="tw-flex tw-items-start"
        data-name="posts-composer_trial-reel_trial-toggle"
      >
        <Toggle
          checked={value.is_trial_reel || false}
          onChange={() =>
            onChange((prev) => ({
              is_trial_reel: !prev.is_trial_reel,
              share_to_everyone_automatically: !prev.is_trial_reel
                ? prev.share_to_everyone_automatically
                : false,
            }))
          }
        />
        <div className="tw-ml-3 tw-flex tw-flex-col tw-gap-1">
          <div className="tw-flex tw-items-center tw-gap-2">
            <span className="tw-text-sm tw-font-semibold tw-text-grayscale-180">
              {t('trialReel.trial.label', 'Trial')}
            </span>
            <Badge variant="gray">{t('newTag', 'New')}</Badge>
          </div>
          <p className="tw-text-sm tw-text-grayscale-140">
            {t(
              'trialReel.trial.description',
              "Your reel will only be shown to non-followers at first and won't appear on your profile.",
            )}
          </p>
          <div className="tw-flex">
            <Link
              to="https://about.fb.com/news/2024/12/trial-reels-try-content-non-followers-first-see-what-perfoms-best/"
              target="_blank"
            >
              <Button variant="plain" className="tw-text-primary-100">
                {t('learnMore', 'Learn more')}
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {value.is_trial_reel && (
        <div
          className="tw-flex tw-items-start"
          data-name="posts-composer_trial-reel_share-automatically-toggle"
        >
          <Toggle
            checked={value.share_to_everyone_automatically || false}
            onChange={() =>
              onChange((prev) => ({
                is_trial_reel: prev.is_trial_reel,
                share_to_everyone_automatically:
                  !prev.share_to_everyone_automatically,
              }))
            }
          />
          <div className="tw-ml-3 tw-flex tw-flex-col tw-gap-1">
            <span className="tw-text-sm tw-font-semibold tw-text-grayscale-180">
              {t(
                'trialReel.shareAutomatically.label',
                'Share to everyone automatically',
              )}
            </span>
            <p className="tw-text-sm tw-text-grayscale-140">
              {t(
                'trialReel.shareAutomatically.description',
                'Trial reels that get a lot of views within the first 72 hours will automatically be shared to everyone.',
              )}
            </p>
          </div>
        </div>
      )}

      {value.is_trial_reel && (
        <Alert variant="warning">
          {t(
            'trialReel.warning.followerRequirement',
            'Trial Reels are only available for accounts with 1,000+ followers.',
          )}
        </Alert>
      )}
    </div>
  );
};

export default PostComposerTrialReelInstagram;
